import { render, staticRenderFns } from "./Erp.vue?vue&type=template&id=3352c72c&scoped=true"
import script from "./Erp.vue?vue&type=script&lang=js"
export * from "./Erp.vue?vue&type=script&lang=js"
import style0 from "./Erp.vue?vue&type=style&index=0&id=3352c72c&prod&lang=scss&scoped=true"
import style1 from "./Erp.vue?vue&type=style&index=1&id=3352c72c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352c72c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VTextField,VToolbarTitle})
